<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Coordonnées du gestionnaire de compte</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Raison sociale</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_RS"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Civilité</td>
        <td>
          <select-civilite
            [(ngModel)]="administre.civilite_ID"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-civilite>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Nom, prénom</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Nom"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Prenom"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Adresse</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Adresse1"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Complément</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Adresse2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">CP, Ville</td>
        <td class="flex gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="6"
              [(ngModel)]="administre.administre_CP"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Ville"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">Pays</td>
        <td>
          <select-pays
            [(ngModel)]="administre.pays_ID"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-pays>
        </td>
      </tr>
    </table>
  </mat-card>

  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Communications du gestionnaire de compte</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right items-start">Téléphones</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="administre.administre_Tel1"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="administre.administre_Tel2"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Fax, Mobile</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="administre.administre_Fax"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="administre.administre_Mobile"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Email</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="administre.administre_Email"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
